import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import Link from 'next/link';

import { usePrefetch, type PrefetchConfig } from '~/common/hooks/usePrefetch';

export type PrefetchLinkProps = ComponentPropsWithoutRef<typeof Link> & {
  prefetchConfig?: PrefetchConfig;
  prefetchDelay?: number;
};

export const PrefetchLink = forwardRef<HTMLAnchorElement, PrefetchLinkProps>(
  ({ prefetchConfig, prefetchDelay, children, className, ...linkProps }, ref) => {
    const { onMouseEnter, onMouseLeave, onFocus } = usePrefetch(prefetchConfig, {
      delay: prefetchDelay,
    });

    return (
      <Link
        ref={ref}
        className={className}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onFocus={onFocus}
        {...linkProps}
      >
        {children}
      </Link>
    );
  }
);

PrefetchLink.displayName = 'PrefetchLink';
